/**
 * BuyNowButton - 独立结算按钮（不影响购物车原有内容）
 * 
 * 实现原理：
 * 1. 点击时先备份当前购物车
 * 2. 清空购物车后添加当前商品
 * 3. 跳转结账页面
 * 4. 用户返回时自动恢复原始购物车
 * 
 * @param {String} data-variant-id - 商品变体ID
 * @param {String} data-quantity - 购买数量（默认1）
 */
if (!customElements.get("buy-now-button")) {
  class BuyNowButton extends HTMLElement {
    // 状态标记
    _marks = {
      loading: "loading",
    };

    constructor() {
      super();
      this._cartBackupKey = 'cart_backup_' + window.location.pathname;
    }

    connectedCallback() {
      this.updateQuantity();
      this.elements = {
        loadingSpinner: this.querySelector(".loading__spinner"),
      };
      this.addEventListener("click", (e) => {
        this.startLoading();
        this.checkout().finally(() => {
          this.finishLoading();
        });
      });
      
      // 页面加载时检查是否需要恢复购物车
      // this.restoreCartIfNeeded();
    }

    // 恢复购物车逻辑
    async restoreCartIfNeeded() {
      const backup = sessionStorage.getItem(this._cartBackupKey);
      if (!backup) return;

      try {
        const { items, note, attributes } = JSON.parse(backup);
        await fetch('/cart/clear.js', { method: 'POST' });
        
        if (items.length > 0) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
        }

        // 恢复购物车备注和属性
        if (note || attributes) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note, attributes })
          });
        }
      } finally {
        sessionStorage.removeItem(this._cartBackupKey);
      }
    }

    // 获取当前购物车快照
    async _getCartSnapshot() {
      const cart = await fetch('/cart.js').then(res => res.json());
      return {
        items: cart.items.map(item => ({
          id: item.variant_id,
          quantity: item.quantity,
          properties: item.properties
        })),
        note: cart.note,
        attributes: cart.attributes
      };
    }

    // 核心结账逻辑
    async checkout() {
      try {
        // 1. 备份当前购物车
        const cartBackup = await this._getCartSnapshot();
        sessionStorage.setItem(this._cartBackupKey, JSON.stringify(cartBackup));

        // 2. 清空并添加当前商品
        await fetch('/cart/clear.js', { method: 'POST' });
        
        const variantIds = this.getAttribute("data-variant-id").split(",");
        const quantities = (this.getAttribute("data-quantity") || "1").split(",");
        
        const items = variantIds.map((id, index) => ({
          id,
          quantity: parseInt(quantities[index] || quantities[0] || 1)
        }));

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        // 3. 跳转结账页
        window.location.href = '/checkout';

      } catch (error) {
        console.error("独立结账失败:", error);
        throw error;
      }
    }

    updateQuantity() {
      const mainQtyElement = document.querySelector(".product-form__main_quantity");
      if (mainQtyElement) {
        const quantityInput = mainQtyElement.querySelector('quantity-input input[name="quantity"]');
        if (quantityInput) {
          const updateDataQuantity = () => {
            const inputValue = quantityInput.value;
            let quantityArray = (this.getAttribute("data-quantity") || "1").split(",");
            quantityArray[0] = inputValue;
            this.setAttribute("data-quantity", quantityArray.join(","));
          };
          quantityInput.addEventListener("change", updateDataQuantity);
          updateDataQuantity();
        }
      }
    }

    startLoading() {
      this.setAttribute("aria-disabled", "true");
      this.classList.add(this._marks.loading);
      this.elements.loadingSpinner?.classList.remove("hidden");
    }

    finishLoading() {
      this.removeAttribute("aria-disabled");
      this.classList.remove(this._marks.loading);
      this.elements.loadingSpinner?.classList.add("hidden");
    }
  }

  customElements.define("buy-now-button", BuyNowButton);
}
